"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireDefault(require("react"));
require("./TaskTrueFalse.scss");
var _CompletedContext = require("../CompletedContext");
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));
function checkBool(str) {
  if (str === "true") {
    return true;
  } else if (str === "false") {
    return false;
  }
  return Boolean(str);
}
var TaskTrueFalse = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskTrueFalse, _React$Component);
  var _super = (0, _createSuper2.default)(TaskTrueFalse);
  function TaskTrueFalse(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskTrueFalse);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.correct = null;
      _this.state.showModal = false;
    }
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(TaskTrueFalse, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "handleClick",
    value: function handleClick(input) {
      this.setState({
        correct: checkBool(this.props.correct) === input,
        completed: checkBool(this.props.correct) === input,
        showModal: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task task-true-false",
        style: this.props.style
      }, /*#__PURE__*/_react.default.createElement("p", null, this.props.question), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        variant: this.state.correct && checkBool(this.props.correct) === true ? "solid" : "outline",
        className: "bdg-tf-button",
        disabled: this.state.correct,
        onClick: function onClick() {
          _this3.handleClick(true);
        }
      }, "True"), /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        variant: this.state.correct && checkBool(this.props.correct) === false ? "solid" : "outline",
        className: "bdg-tf-button",
        disabled: this.state.correct,
        onClick: function onClick() {
          _this3.handleClick(false);
        }
      }, "False")), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        correct: this.state.correct,
        show: this.state.showModal,
        onHide: function onHide() {
          _this3.setState({
            showModal: false
          });
        }
      }, this.state.correct ? this.props.correctFeedback : this.props.incorrectFeedback));
    }
  }]);
  return TaskTrueFalse;
}(_react.default.Component);
exports.default = TaskTrueFalse;
TaskTrueFalse.contextType = _CompletedContext.CompletedContext;